import React, { useContext, useEffect } from 'react';
import {
  Router, Switch, Route, useLocation,
} from 'react-router-dom';
// import { useMediaQuery } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import ProtectedRoute from 'Shared/ProtectedRoute';
import ConnectedStore from 'Shared/ConnectedStore';
import { Provider, initialState, UserReducer } from 'Shared/UserContext';
import ConfigContext, {
  Provider as ProviderConfig,
  initialState as initConfig,
  ConfigReducer,
} from 'Shared/ConfigContext';
import history from 'config/history';
import Users from 'Components/Users';
import Catalog from 'Components/Catalog';
import ProductDetailDrawer from 'Components/Catalog/ProductDetailDrawer';
import Orders from 'Components/Orders';
import OrderDetail from 'Components/Orders/OrderDetail';
import Dashboard from 'Components/Dashboard';
import AccountSettings from 'Components/AccountSettings';
import Reglements from 'Components/Reglements';
import ReglementDetail from 'Components/Reglements/ReglementDetail';
import CartPage from 'Components/CartPage/V2';
import CartDetail from 'Components/CartPage/V2/CartDetail';
import Factures from 'Components/Factures';
import FactureDetail from 'Components/Factures/FactureDetail';
import Announcements from 'Components/Announcements';
import { initPaniers, setCommercials, setExpeditions } from 'Shared/ConfigContext/Actions';
import useNetworkLoader from 'hooks/useNetworkLoader';
import { getCarts, getCommercials, getExpeditions } from 'Services';
import { JWE_KEY } from 'Utils/crypt';
import ReactPiwik from 'react-piwik';
import { APP_PATH_NAME } from 'Utils/ulilities';
import Login from './Components/Login';
import Media from './Components/Media';
import Account from './Components/Account';
import MfaEnrollment from './Components/MFA/MfaEnrollment';
import MfaVerification from './Components/MFA/MfaVerification';
import MfaManagement from './Components/MFA/MfaManagement';
import UpdatePassword from './Components/UpdatePassword';

const CatalogKeepAlive = () => <Catalog />;

const AppRoutes = ({ isAdmin }) => {
  const location = useLocation();
  const background = location.state?.background;
  const isProductRoute = location.pathname.startsWith('/products/');
  return (
    <>
      <Switch location={background || location}>
        <Route path="/login" component={Login} exact />
        <Route path="/update-password" component={UpdatePassword} exact />
        <Route path="/mfa/enroll" component={MfaEnrollment} exact />
        <Route path="/mfa/verify" component={MfaVerification} exact />
        <ProtectedRoute path="/mfa/manage" component={MfaManagement} exact />
        <ProtectedRoute path="/users" component={Users} exact />
        <ProtectedRoute path="/cart" component={CartPage} exact />
        <ProtectedRoute path="/cart/:id" component={CartDetail} exact />
        <ProtectedRoute path="/announcements" component={Announcements} exact />
        <ProtectedRoute path="/media" component={Media} exact />
        <ProtectedRoute path="/account" component={Account} exact />
        <ProtectedRoute path="/orders" component={Orders} exact />
        <ProtectedRoute path="/orders/sales/:id" component={OrderDetail} exact />
        <ProtectedRoute path="/orders/:id" component={OrderDetail} exact />
        <ProtectedRoute path="/reglements" component={Reglements} exact allowMF={false} />
        <ProtectedRoute path="/reglements/:id" component={ReglementDetail} exact allowMF={false} />
        <ProtectedRoute path="/dashboard" component={Dashboard} exact allowMF={false} />
        <ProtectedRoute path="/account-settings" component={AccountSettings} exact />
        <ProtectedRoute path="/factures" component={Factures} exact />
        <ProtectedRoute path="/factures/:id" component={FactureDetail} exact />
        <ProtectedRoute path={['/', APP_PATH_NAME.catalog, '/products/:reference']} component={isAdmin ? Users : CatalogKeepAlive} />
      </Switch>
      {isProductRoute && <ProductDetailDrawer />}
    </>
  );
};

const MATOMO_SITE_IDS = {
  development: 1,
  production: 2, // uat
  prod: 3,
};

const piwik = new ReactPiwik({
  url: 'https://analytics.copima.ma',
  siteId:
    window.location.host === 'edge.copima.ma'
      ? MATOMO_SITE_IDS.prod
      : MATOMO_SITE_IDS[process.env.NODE_ENV],
});

function App() {
  const {
    dispatch,
    state: { profile },
  } = useContext(ConfigContext);
  const { callApi } = useNetworkLoader();

  const user = JSON.parse(localStorage.user || '{}');

  useEffect(() => {
    if (profile?.id && localStorage.getItem('token') && localStorage.getItem(JWE_KEY)) {
      ReactPiwik.push(['setUserId', profile.code || `id_${profile.id}`]);
      const browserType = `Sys: ${navigator.platform}// Name: ${navigator.appCodeName}, ${navigator.appName} // Version: ${navigator.appVersion}`;
      ReactPiwik.push(['trackEvent', 'Browser', browserType]);
      callApi(getCommercials, (data) => {
        dispatch(
          setCommercials(
            data.map((item) => ({ id: item.id, name: `${item.firstName} ${item.lastName}` })),
          ),
        );
      });
      callApi(getExpeditions, (data) => dispatch(setExpeditions(data)));
      callApi(getCarts, (data) => dispatch(initPaniers(data)), false);
    }
  }, [profile]);

  return (
    <Router history={piwik.connectToHistory(history, false)}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
        hideProgressBar
        closeButton={false}
        style={{ top: '16px', width: '450px', zIndex: 99999 }}
      />
      <AppRoutes isAdmin={user.role === 'ROLE_ADMIN'} />
    </Router>
  );
}
const ConnectedToUserContext = ConnectedStore(App, UserReducer, initialState, Provider);
export default ConnectedStore(ConnectedToUserContext, ConfigReducer, initConfig, ProviderConfig);
